<template>
  <section class="folder-tiles" v-if="folders.length">
    <div class="folder-tiles-header" @click="toggleFolders">
      <div class="folder-tiles-title">Mape</div>
      <div class="folder-tiles-actions">
        <v-icon>{{ areFoldersShown ? 'expand_less' : 'expand_more' }}</v-icon>
      </div>
    </div>
    <div
      class="folder-tiles-content"
      ref="folderTilesContent"
      @transitionend="$emit('layout-change')"
    >
      <r-cards
        :cards="cards"
        button-text="Odpri"
        compact
        @click="onCardClick"
      />
    </div>
  </section>
</template>

<script>
import RCards from 'design-system/components/RCards.vue'
import VIcon from 'design-system/VIcon.vue'

export default {
  components: {
    RCards,
    VIcon,
  },
  props: {
    folders: { type: Array, required: true },
    selectedFolderId: { type: Number, default: null },
  },
  data () {
    return {
      areFoldersShown: true,
    }
  },
  mounted () {
    window.addEventListener('resize', this.updateContentHeight)
    this.updateContentHeight()
    this.$nextTick(() => this.$emit('layout-change'))
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateContentHeight)
  },
  watch: {
    folders () {
      this.$nextTick(() => this.updateContentHeight())
    },
    selectedFolderId (folderId) {
      if (folderId != null && !this.areFoldersShown) {
        this.areFoldersShown = true
      }
      this.$nextTick(() => this.updateContentHeight())
    },
  },
  computed: {
    cards () {
      return this.folders.map(folder => ({
        ...folder,
        iconName: 'folder',
        buttonText: folder.id === this.selectedFolderId ? 'Zapri' : 'Odpri',
        active: folder.id === this.selectedFolderId,
      }))
    },
  },
  methods: {
    toggleFolders () {
      this.areFoldersShown = !this.areFoldersShown
      this.updateContentHeight()
    },
    updateContentHeight () {
      if (!this.$refs.folderTilesContent) {
        return
      }

      this.$refs.folderTilesContent.style.maxHeight = this.areFoldersShown ?
        `${this.$refs.folderTilesContent.scrollHeight}px` :
        0
    },
    onCardClick ({ card }) {
      this.$emit('select', card.id === this.selectedFolderId ? null : card)
    },
  },
}
</script>

<style lang="scss" scoped>
.folder-tiles {
  border-radius: 8px;
  margin-top: 16px;
  margin-bottom: 16px;
  background-color: white;
  color: black;
  user-select: none;
}

.folder-tiles-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  cursor: pointer;
}

.folder-tiles-title {
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
}

.folder-tiles-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.folder-tiles-content {
  overflow: hidden;
  max-height: 0;
  padding: 0 24px;
  transition: .3s cubic-bezier(.25, .8, .25, 1);
  transition-property: max-height;

  ::v-deep .cards {
    margin: 0 0 16px;
    place-content: flex-start;
  }
}
</style>
